import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

// Today’s calls: Show exact time ,Yesterday’s calls: Show "Yesterday"
// Calls from the past week: Show the day name (e.g., "Monday") Older calls: Show the date (MM/DD/YYYY format)
export function formatCallTimestamp(timestamp) {
  const callDate = dayjs(timestamp);
  const now = dayjs();

  if (callDate.isToday()) {
    return callDate.format("HH:mm"); // 24-hour format
  } else if (callDate.isYesterday()) {
    return "Yesterday";
  } else if (callDate.isAfter(now.subtract(7, "day"))) {
    return callDate.format("dddd"); // Day of the week
  } else {
    return callDate.format("DD/MM/YYYY"); // DD/MM/YYYY format
  }
}
// Today’s calls: Show exact time ,Yesterday’s calls: Show "Yesterday . HH:mm"
// Calls from the past week: Show the day name (e.g., "Monday . HH:mm") Older calls: Show the date (MM/DD/YYYY format)
export function formatCallMobileTimestamp(timestamp) {
  const callDate = dayjs(timestamp);
  const now = dayjs();

  if (callDate.isToday()) {
    return callDate.format("HH:mm"); // 24-hour format
  } else if (callDate.isYesterday()) {
    return `Yesterday . ${callDate.format("HH:mm")}`;
  } else if (callDate.isAfter(now.subtract(7, "day"))) {
    return `${callDate.format("dddd")} . ${callDate.format("HH:mm")}`; // Day of the week
  } else {
    return `${callDate.format("DD/MM/YYYY")} . ${callDate.format("HH:mm")}`; // DD/MM/YYYY format
  }
}

/**
 * Returns the difference in seconds between the given call date and now.
 * If date is invalid or in the future, returns 0.
 */
export const getElapsedSecondsFromCallDate = (date) => {
  if (!date) return 0;

  const now = dayjs();
  const callStart = dayjs(date);

  const diff = now.diff(callStart, "second");

  return diff > 0 ? diff : 0;
};

/**
 * Formats a duration given in seconds into a string like HH:MM:SS or MM:SS
 * @param totalSeconds Total duration in seconds
 * @returns Formatted time string
 */
export const formatTimeSeconds = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const paddedMinutes = String(minutes).padStart(2, "0");
  const paddedSeconds = String(seconds).padStart(2, "0");

  if (hours > 0) {
    const paddedHours = String(hours).padStart(2, "0");
    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  }

  return `${paddedMinutes}:${paddedSeconds}`;
};
